import { type DataObjectsManager, type IDataObject } from '@inpart-io/devtools-iap';
import { type Module } from 'vuex';

import { getActions } from './actions';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGINATION, DEFAULT_SEARCH_KEY } from './constants';
import { getGetters } from './getters';
import { getMutations } from './mutations';
import { type ISearchState } from './types';

export function getSearchModule<T extends IDataObject>(manager?: DataObjectsManager<T>): Partial<Module<ISearchState, unknown>> {
    const pagination = new Map();
    pagination.set(DEFAULT_SEARCH_KEY, Object.assign({}, DEFAULT_PAGINATION));

    return {
        namespaced: true,
        state: {
            search: new Map(),
            pagination,
            timestamp: null
        },
        getters: getGetters(),
        actions: getActions(manager),
        mutations: getMutations()
    };
}

export { DEFAULT_PAGE_SIZE, DEFAULT_PAGINATION, DEFAULT_SEARCH_KEY };
